<!-- class="hogehoge" → styleで.hogehogeでスタイル指定できる -->
<template>
  <div>
    <div class="container">
      <div class="breadCrumbsContainer" style="display: flex;">
        ログインID確認用のメールアドレスをご入力下さい。
        <div class="headerBtn" @click="screenTransition()" style="margin: 0px 0px 0px 20px;">パスワード再発行画面に戻る</div>
      </div>
      <!-- ローディング -->
      <div v-if="sendLodingFlg">
        <vue-loading
          type="cylon"
          color="#1b7e47"
          :size="{ width: '150px', height: '150px' }"
        >
        </vue-loading>
        <div style="padding: 0px 0px 30px 0px;">Now loading...</div>
      </div>
      <!-- 更新エラー表示 -->
      <div v-if="sendErrorFlg" style="padding: 0px 0px 30px 0px; margin: auto;">
        <div　class="errMsg">
          <div class="errSpan" style="font-size:x-large;">
            メール送信中に問題が発生しました。
          </div>
        </div>
      </div>
      <!-- 完了表示 -->
      <div v-if="completeFlg" style="padding: 0px 0px 30px 0px; margin: auto;">
        <div class="errSpan" style="font-size:x-large;">
          ログインIDをご入力のメールアドレスに送信しました。
        </div>
      </div>
      <form>
        <validation-observer ref="obs" v-slot="ObserverProps">
          <p class="inputTitle">メールアドレス</p>
          <validation-provider name="メールアドレス" rules="required|emailVaridate|max:255" mode="lazy">
            <div slot-scope="ProviderProps">
              <input class="text small" style="width: 500px" v-model="email">
              <div class="errMsg" v-if="ProviderProps.errors[0]">
                <span class="errSpan">
                  {{ ProviderProps.errors[0] }}
                </span>
              </div>
            </div>
          </validation-provider>
          <div class="buttonGroup" v-if="!completeFlg">
            <button class="btn" type="button" @click="confirm"
              v-bind:class="{ disabled: ObserverProps.invalid || !ObserverProps.validate, active: !ObserverProps.invalid && ObserverProps.validate}"
              :disabled="ObserverProps.invalid || !ObserverProps.validated">送信
            </button>
          </div>
        </validation-observer>
      </form>
    </div>
  </div>

</template>

<script lang='ts'>
import { Component, Vue } from 'vue-property-decorator';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { required, max, min, email } from 'vee-validate/dist/rules';
import ApiClient from '../services/ApiClient';
import { VueLoading } from 'vue-loading-template';

export default {
  title: 'パスワード再発行準備',
  components: {
    ValidationProvider,
    ValidationObserver,
    VueLoading,
  },
  data() {
    return {
      email: '',
      // ローディング
      sendLodingFlg: false,  // メール送信ローディングフラグ
      sendErrorFlg: false,   // メール送信時エラーフラグ
      loginIdErrorFlg: false,   // メール送信時エラーフラグ
      completeFlg: false,       // メール送信完了後フラグ
    };
  },
  computed: {
  },
  watch: {
  },
  methods: {
    // 変更ボタン押下時処理
    async confirm() {
      try {
        // TODO suzuno パス系や固定値は定数ファイルにまとめたい……
        // 開発環境
        // const RESET_PASSWORD_URL = 'http://ep-manager-front-dev-s3-front-bucket.s3-website-ap-northeast-1.amazonaws.com/users/forgot-password';
        // アート検証環境
        // const RESET_PASSWORD_URL = 'http://ep-manager-front-dev2-s3-front-bucket.s3-website-ap-northeast-1.amazonaws.com/users/forgot-password';
        // 本番環境
        const RESET_PASSWORD_URL =  'https://ep-manager.com/users/forgot-password';
        this.sendErrorFlg = false;
        this.sendLodingFlg = true;
        const restResourceService = new ApiClient();
        const users = await restResourceService.getLoginId(this.email);
        // メールに使用するTemplateData
        const templateData = {
          users: [],
          url: RESET_PASSWORD_URL
        };
        users.forEach((user, i) => {
          const role= {
            '1': '運営管理者',
            '3': '事業者',
            '5': '支店',
            '7': '技能者'
          }[user.role] || '';
          templateData.users.push(
            {
              name: user.name,
              loginid: user.userName,
              role
            }
          );
        });
        // メール送信API呼出
        await restResourceService.loginIdForgetMail(this.email, templateData);
        this.completeFlg = true;
      } catch (error) {
        this.sendErrorFlg = true;
        this.errorMessage = error.message;
        throw error;
      } finally {
        this.sendLodingFlg = false;
      }
    },
    // パスワード再設定画面へ遷移
    screenTransition() {
      this.$router.push('/users/forgot-password');
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../style/variables.scss";

</style>
